import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "site-footer" }
const _hoisted_2 = { class: "wrapper" }
const _hoisted_3 = { class: "footer-link" }
const _hoisted_4 = {
  id: "privacyLink",
  href: "#"
}
const _hoisted_5 = {
  id: "termsLink",
  href: "#"
}
const _hoisted_6 = { class: "footer-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("ul", null, [
          _createElementVNode("li", null, [
            _createElementVNode("a", _hoisted_4, _toDisplayString($data.constants.PRIVACY_POLICY_LINK), 1)
          ]),
          _createElementVNode("li", null, [
            _createElementVNode("a", _hoisted_5, _toDisplayString($data.constants.TERMS_CONDITIONS_LINK), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_6, _toDisplayString($data.constants.COPY_RIGHT_TEXT), 1),
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "clear" }, null, -1))
    ])
  ]))
}